/* global axios */

import ApiClient from './ApiClient';

// Shared query string for the JSON list and the CSV export.
const buildParams = ({ page, userId, auditableType, from, to } = {}) => {
  const params = new URLSearchParams();
  if (page) params.append('page', page);
  if (userId) params.append('user_id', userId);
  if (auditableType) params.append('auditable_type', auditableType);
  if (from) params.append('from', from);
  if (to) params.append('to', to);
  return params;
};

class AuditLogs extends ApiClient {
  constructor() {
    super('audit_logs', { accountScoped: true });
  }

  get({ page, userId, auditableType, from, to } = {}) {
    const query = buildParams({
      page,
      userId,
      auditableType,
      from,
      to,
    }).toString();
    return axios.get(query ? `${this.url}?${query}` : this.url);
  }

  export({ userId, auditableType, from, to } = {}) {
    const query = buildParams({
      userId,
      auditableType,
      from,
      to,
    }).toString();
    const url = query ? `${this.url}.csv?${query}` : `${this.url}.csv`;
    return axios.get(url, { responseType: 'blob' });
  }
}

export default new AuditLogs();
